import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Registration,
  RegistrationActivity
} from '@/features/registration';
import type { RejectStageRequest, ReviewMetrics } from '../types';

const { REVIEW, REGISTRATIONS } = API_ENDPOINTS;

export const reviewApi = {
  getMetrics: () => apiClient.get<ReviewMetrics>(REVIEW.METRICS),

  getActivities: (registrationId: number) =>
    apiClient.get<RegistrationActivity[]>(
      REGISTRATIONS.ACTIVITIES(registrationId)
    ),

  advanceStage: (registrationId: number) =>
    apiClient.post<Registration>(REGISTRATIONS.ADVANCE_STAGE(registrationId), {
      from: 'review'
    }),

  rejectStage: (registrationId: number, data: RejectStageRequest) =>
    apiClient.post<Registration>(REVIEW.REJECT_STAGE(registrationId), data)
};
